// extracted by mini-css-extract-plugin
export default {"root":"Stats-root","stat":"Stats-stat","summary":"Stats-summary","summaryDate":"Stats-summaryDate","dateExtra":"Stats-dateExtra"};